import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import { Form, Row, Col, Button } from "react-bootstrap";
// import google_img from "../Assets/Images/google.png";
// import facebook_img from "../Assets/Images/facebook.png";
import _fetch from "../config/api";
import toasted from "../config/toast";
import { api_url } from "../config/Config";


// const api_url = "http://localhost:5000/api/"; // 🔹 Change this to your backend base URL

const Register = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const [selectCheckbox, setSelectCheckbox] = useState(false);

  const togglePassword = () => setShowPassword((prev) => !prev);
  const toggleConfirmPassword = () => setShowConfirmPassword((prev) => !prev);

  // Form States
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [referCode, setReferCode] = useState("");

  const submitRegister = async (e) => {
    e.preventDefault();
    if (!selectCheckbox) {
      toasted.error("Please agree to the terms and conditions.");
      return;
    }

    if (password !== confirmPassword) {
      toasted.error("Passwords do not match.");
      return;
    }

    setBtnDisable(true);

    const data = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone_number: phoneNumber,
      password: password,
      confirm_password: confirmPassword,
      refer_code: referCode || "",
    };

    try {
      const res = await _fetch(`${api_url}auth/signup`, "POST", data, {});

      if (res?.status === true) {
        toasted.success(res?.message || "Registration successful!");

        // store token and user info
        localStorage.setItem("auth", "true");
        localStorage.setItem("accessToken", res?.token);
        localStorage.setItem("user", JSON.stringify(res?.userDetails));

        // Navigate to next page if using react-router-dom
        // Navigate("/dashboard");
      } else {
        toasted.error(res?.message || "Registration failed.");
      }
    } catch (error) {
      toasted.error("Something went wrong. Please try again.");
      console.error("Signup error:", error);
    } finally {
      setBtnDisable(false);
    }
  };

  const getIconClass = (show) => {
    return show ? "bi bi-eye-fill" : "bi bi-eye-slash-fill";
  };

  return (
    <div className="Login_sec">
      <Container>
        <Row className="justify-content-center">
          <Col lg={6}>
            <div className="login_form">
              <div className="login_user">
                <span>
                  <i className="bi bi-person-fill"></i>
                </span>
                <h5>Sign Up</h5>
              </div>

              <Form className="signup-form" onSubmit={submitRegister}>
                {/* First & Last Name */}
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formFirstName">
                      <Form.Label>
                        First Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Ex: John"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formLastName">
                      <Form.Label>
                        Last Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Ex: Doe"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Email & Phone */}
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formEmail">
                      <Form.Label>
                        Email Address <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formPhone">
                      <Form.Label>
                        Phone Number <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter phone number"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Password & Confirm Password */}
                <Row>
                  <Col md={6}>
                    <Form.Group
                      className="mb-3 position-relative"
                      controlId="formPassword"
                    >
                      <Form.Label>
                        Password <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder="Minimum 8 characters long"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      <i
                        className={`${getIconClass(showPassword)} password-toggle-icon`}
                        onClick={togglePassword}
                      ></i>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group
                      className="mb-3 position-relative"
                      controlId="formConfirmPassword"
                    >
                      <Form.Label>
                        Confirm Password <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Re-enter password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                      <i
                        className={`${getIconClass(showConfirmPassword)} password-toggle-icon`}
                        onClick={toggleConfirmPassword}
                      ></i>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Refer Code */}
                <Form.Group className="mb-3" controlId="formReferCode">
                  <Form.Label>
                    Refer Code <span className="text-secondary">(Optional)</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Use referral code"
                    value={referCode}
                    onChange={(e) => setReferCode(e.target.value)}
                  />
                </Form.Group>

                {/* Terms & Conditions */}
                <Form.Group className="mb-3" controlId="formBasicCheckbox">
                  <div className="login_checkbox">
                    <Form.Check
                      type="checkbox"
                      label="I agree to your Terms and Conditions"
                      checked={selectCheckbox}
                      onChange={(e) => setSelectCheckbox(e.target.checked)}
                    />
                  </div>
                </Form.Group>

                <div className="login_btn text-center">
                  <Button
                    type="submit"
                    disabled={btnDisable}
                    className="btn btn-primary w-100"
                  >
                    {btnDisable ? "Signing Up..." : "Sign Up"}
                  </Button>
                </div>
              </Form>

              {/* Social Login */}
              <div className="other_sign text-center mt-4">
                <p>Or Continue with</p>
                <div className="social_btn_sign">
                  <a href="#">
                    {/* <img src={google_img} alt="google_icon" /> */}
                  </a>
                  <a href="#">
                    {/* <img src={facebook_img} alt="facebook_icon" /> */}
                  </a>
                </div>
                <h6 className="mt-3">
                  Already have an account? <a href="/login">Sign In</a>
                </h6>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Register;
